import React from 'react';

export const ListBlockIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/list/blocked' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          id='ci:list-plus'
          transform='translate(2.500000, 6.666667)'
          fill='currentColor'
          fillRule='nonzero'
        >
          <path
            d='M12.5,12.7480159 L0.0992063492,12.7480159 L0.0992063492,10.2678571 L12.5,10.2678571 L12.5,12.7480159 Z M14.4321289,7.78769841 L0.0992063492,7.78769841 L0.0992063492,5.30753968 L14.4321289,5.30753968 L14.4321289,7.78769841 Z M16.2202381,2.82738095 L0.0992063492,2.82738095 L0.0992063492,0.347222222 L16.2202381,0.347222222 L16.2202381,2.82738095 Z'
            id='Shape'
          ></path>
        </g>
        <path
          d='M27.4890625,18.2422526 C27.4890625,21.0589048 25.2057147,23.3422526 22.3890625,23.3422526 C19.5724103,23.3422526 17.2890625,21.0589048 17.2890625,18.2422526 C17.2890625,15.4256004 19.5724103,13.1422526 22.3890625,13.1422526 C25.2057147,13.1422526 27.4890625,15.4256004 27.4890625,18.2422526 Z M26.2140665,18.2422526 C26.2152174,17.4479221 25.9679446,16.6731144 25.5068625,16.0263026 L20.1731125,21.3600526 C21.3396724,22.189196 22.8715174,22.2977224 24.1433229,21.6413297 C25.4151285,20.9849371 26.2140665,19.6734552 26.2140665,18.2422526 L26.2140665,18.2422526 Z M24.6050125,15.1244526 C23.0836964,14.0429649 21.0039614,14.2174475 19.6841094,15.5372995 C18.3642574,16.8571515 18.1897748,18.9368865 19.2712625,20.4582026 L24.6050125,15.1244526 L24.6050125,15.1244526 Z'
          id='Shape'
          fill='#D64B4B'
          fillRule='nonzero'
        ></path>
      </g>
    </svg>
  );
};
